import { BrowserRouter as Router, Routes, Route } from "react-router-dom"; // Import React Router
import "./App.css";
import Table from "./pages/Tabale";
import DocumentUpload from "./pages/DocumnetUpload";

function App() {
  return (
    <Router>
      <div className="App" style={{ margin: "20px" }}>
        <Routes>
          <Route path="/" element={<Table />} />
          <Route path="/document-upload" element={<DocumentUpload />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
